export const environment = {
    ENVIRONMENT: 'prod',
    CHATBOT_BASE_URL: 'https://chatbot.nopalcyber.com',
    CHATBOT_BUILD_VERSION: '1.0.0',
    DOMAIN_PREFIX: 'nopalgo-chatbot',
    DOMAIN: 'nopalcyber.com',
    CHATBOT_CLOUD_FRONT_URL :'https://d298qmidobjk3h.cloudfront.net'
};